var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCloseCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.81443 5.31244C6.00971 5.11719 6.32629 5.11721 6.52154 5.31248L8.50131 7.29246L10.4811 5.31248C10.6763 5.11721 10.9929 5.11719 11.1882 5.31244C11.3835 5.5077 11.3835 5.82428 11.1882 6.01955L9.20838 7.99961L11.1877 9.97915C11.383 10.1744 11.3829 10.491 11.1877 10.6863C10.9924 10.8815 10.6758 10.8815 10.4806 10.6862L8.50131 8.70675L6.52204 10.6862C6.32679 10.8815 6.01021 10.8815 5.81493 10.6863C5.61966 10.491 5.61964 10.1744 5.8149 9.97915L7.79424 7.99961L5.8144 6.01955C5.61914 5.82428 5.61916 5.50769 5.81443 5.31244Z",
    fill: "#842029"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33203 8.00065C1.33203 4.04261 4.54066 0.833984 8.4987 0.833984C12.4567 0.833984 15.6654 4.04261 15.6654 8.00065C15.6654 11.9587 12.4567 15.1673 8.4987 15.1673C4.54065 15.1673 1.33203 11.9587 1.33203 8.00065ZM8.4987 1.83398C5.09294 1.83398 2.33203 4.59489 2.33203 8.00065C2.33203 11.4064 5.09294 14.1673 8.4987 14.1673C11.9044 14.1673 14.6654 11.4064 14.6654 8.00065C14.6654 4.5949 11.9044 1.83398 8.4987 1.83398Z",
    fill: "#842029"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCloseCircle);
export default __webpack_public_path__ + "static/media/ic-close-circle.1a24d6d79e221d5b65db3832cca7d722.svg";
export { ForwardRef as ReactComponent };